import React, {useState} from 'react';
import {View, Text, TouchableOpacity, StyleSheet, FlatList} from 'react-native';
import {Color, globalFontStyle, globalStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import MultiOptionRow from './MultiOptionRow';
import FastImage from "../../../common/FastImage";
import {down_arrow, up_arrow} from "../../../utils/images";
import FormTextLabel from "../../../commonComponents/FormTextLabel";
import {globalConfigurableData} from "../../../utils/globalConstant";

const MultiOptions = ({
  responseMultiEvents,
  multiEventCurrentIndex,
  handleMultiClickEvent,
}) => {

  const [showMore, setShowMore] = useState(false);

  return (
      <View style={{marginTop: 10, marginBottom: 20}}>
      {responseMultiEvents?.slice(0, 2).map((event, index) => {
        return (
          <MultiOptionRow
            key={event.id}
            index={index}
            event={event}
            handleMultiClickEvent={handleMultiClickEvent}
            multiEventCurrentIndex={multiEventCurrentIndex}
          />
        );
      })}
      {showMore && (
        <>
          {responseMultiEvents?.slice(2).map((event, index) => {
            return (
              <MultiOptionRow
                index={index + 2}
                event={event}
                handleMultiClickEvent={handleMultiClickEvent}
                multiEventCurrentIndex={multiEventCurrentIndex}
              />
            );
          })}
        </>
      )}
      {responseMultiEvents.length > 2 && (
          <View
              style={{ paddingVertical: 10, alignItems: "flex-start",}}
          >
            <TouchableOpacity
                onPress={() => {
                  setShowMore(!showMore);
                }}
                style={{
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignItems: 'center',

            }}>
              <FormTextLabel
                labelStyles={{
                  color: globalConfigurableData.secondaryTextColor1,
                  ...globalFontStyle.appFontSubText,
                  marginRight: 5
                }}
                label={showMore ? "Show Less" : "+ more options"}
                rest={{responseMultiEvents: responseMultiEvents.length-2}}/>
              <FastImage
                  source={showMore ? globalConfigurableData?.up_arrow() : globalConfigurableData?.down_arrow()}
                  style={{ width: 15, height: 15 }}
              />
            </TouchableOpacity>
          </View>
      )}
    </View>
  );
};

export default MultiOptions;

const styles = StyleSheet.create({
  categoryStyle: {
    paddingHorizontal: 15,
    paddingVertical: 10,
    marginRight: 10,
  },
  categoryStyleSelected: {
    backgroundColor: Color.black,
    color: Color.bgWhite,
  },
});
